import * as React from 'react';

import { HeroPatternNew } from '@/components/hero-pattern';

import {
  Navigation,
  SectionFooter,
  SectionReadyToRelease,
  SignInOrDashboard,
} from '@/pages/unauthenticated/components';

import { BookDemoSection } from './components/book-demo.section';

export default function BookDemoPage() {
  return (
    <>
      <Navigation>
        <SignInOrDashboard />
      </Navigation>
      <main>
        <HeroPatternNew className="isolate lg:top-132" />
        <BookDemoSection />
        <SectionReadyToRelease />
        <SectionFooter />
      </main>
    </>
  );
}
